'use client'

import { useSidebar } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'

// The table wrapper's classes: as wide as the content area beside the sidebar, and as tall as
// the viewport leaves below the page header.
export const useDynamicTableSizing = () => {
  const { open } = useSidebar()

  return {
    containerClassName: cn(
      'w-full overflow-auto transition-all duration-200',
      'max-h-[calc(100svh-400px)] lg:max-h-[calc(100svh-260px)] 2xl:max-h-[calc(100svh-215px)]',
      open
        ? 'md:max-w-[calc(100vw-48px-10px-var(--sidebar-width))]'
        : 'md:max-w-[calc(100vw-48px-34px-var(--sidebar-width-icon))]',
    ),
  }
}
